export {
    default as TemplateDashboard,
    ITemplateDashboardProps,
    ITemplateDashboardCardHeaderProps,
    ITemplateDashboardFeedbackProps,
    ITemplateDashboardQuestionsProps,
    ITemplateDashboardHeatmapProps,
} from './dashboard';
export {IWeeklyRetroCardProps} from '../../components/dashboard-weekly-retro-card';
